import {array, Decoder, field, object} from 'json-bouncer'
import {MessageWithTranslation} from './MessageWithTranslation.entity.evolve'
import {ProductCalculation, productCalculationDecoder} from './ProductCalculation'
import {messageWithTranslationDecoder} from './MessageWithTranslation.entity.evolve'
import {PriceDefinition, priceDefinitionListDecoder} from './PriceDefinition'
import {ProductShippingService, productShippingServiceDecoder} from './ProductShippingService'
import {Customer, customerDecoder} from './Customer'

export interface ProductCalculationWithAssociations {
    productCalculation: ProductCalculation
    typeMessage: MessageWithTranslation
    formatMessage: MessageWithTranslation
    coverageMessage: MessageWithTranslation
    printMessage: MessageWithTranslation
    paperMessage: MessageWithTranslation
    processingMessage: MessageWithTranslation
    priceDefinitions: PriceDefinition[]
    productShippingService: ProductShippingService
    customers: Customer[]
}

export function  productCalculationWithAssociationsListDecoder(): Decoder<ProductCalculationWithAssociations[]> {
    return array(productCalculationWithAssociationsDecoder())
}

export function productCalculationWithAssociationsDecoder(): Decoder<ProductCalculationWithAssociations> {
    return object({
        productCalculation: field('productCalculation', productCalculationDecoder()),

        typeMessage: field('typeMessage', messageWithTranslationDecoder()),
        formatMessage: field('formatMessage', messageWithTranslationDecoder()),
        coverageMessage: field('coverageMessage', messageWithTranslationDecoder()),
        printMessage: field('printMessage', messageWithTranslationDecoder()),
        paperMessage: field('paperMessage', messageWithTranslationDecoder()),
        processingMessage: field('processingMessage', messageWithTranslationDecoder()),

        priceDefinitions: field('priceDefinitions', priceDefinitionListDecoder()),
        productShippingService: field('productShippingService', productShippingServiceDecoder()),
        customers: field('customers', array(customerDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProductCalculationWithAssociations.ts